export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  editBtn: false,
  delBtn: false,
  align: 'center',
  addBtn: false,
  columnBtn: false,
  menu:false,
  page:false,
  indexFixed:true,
  column: [
  {
    label: '培训课程名称',
    prop: 'activityName',
    overHidden: true,
    width: 120,
  },
  {
    label: '项目组名称',
    prop: 'projectGroupName',
    overHidden: true,
    width: 100,
  },
  {
    label: '子项目名称',
    prop: 'projectName',
    overHidden: true,
    width: 100,
  },
  {
    label: '培训团队名称',
    prop: 'organizedBy',
    overHidden: true,
    width: 120,
  },
  {
    label: '培训老师名称',
    prop: 'lecturer',
    overHidden: true,
    width: 120,
  },
  {
    label: '培训开始时间',
    prop: 'startTime',
    sortable: true,
    overHidden: true,
    width: 135,
  },
  {
    label: '培训结束时间',
    prop: 'endTime',
    sortable: true,
    overHidden: true,
    width: 135,
  },
  {
    label: '可报名人数',
    prop: 'canEnrollCount',
    overHidden: true,
    width: 100,
  },
  {
    label: '报名人数',
    prop: 'enrollmentCount',
    overHidden: true,
    width: 80,
  },
  {
    label: '报名成功人数',
    prop: 'enrollmentSuccessCount',
    overHidden: true,
    width: 120,
  },
  {
    label: '签到人数',
    prop: 'checkedInCount',
    overHidden: true,
    width: 80,
  },
  {
    label: '参与率',
    prop: 'participationRate',
    sortable: true,
    overHidden: true,
    solt: true,
    width: 90,
  },
  {
    label: '问卷参与人数',
    prop: 'questionnaireParticipantCount',
    sortable: true,
    overHidden: true,
    solt: true,
    width: 135,
  },
  {
    label: '总评分',
    prop: 'questionnaireTotalScore',
    sortable: true,
    overHidden: true,
    solt: true,
    width: 90,
  },
  {
    label: '平均评分',
    prop: 'questionnaireAverageScore',
    sortable: true,
    overHidden: true,
    solt: true,
    width: 120,
  },
  {
    label: '问卷参与人数/签到人数',
    prop: 'questionnaireParticipationRate',
    sortable: true,
    overHidden: true,
    solt: true,
    width: 200,
  }]
}

export const userTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  editBtn: false,
  delBtn: false,
  align: 'center',
  addBtn: false,
  columnBtn: false,
  menu:false,
  page:false,
  indexFixed:true,
  column: [
  {
    label: '员工号',
    prop: 'unionId',
    span: 24,
    fixed: 'left'
  },      
  {
    label: 'Birth Name',
    prop: 'realname',
    span: 24,
    fixed: 'left',
  },        
  {
    label: 'Full Name',
    prop: 'nickname',
    span: 24,
    fixed: 'left',
  },
  {
    label: '手机号',
    width: 160,
    prop: 'phoneNumber',
    solt: true,
    span: 24,
  },
  {
    label: 'Position Name',
    width: 160,
    prop: 'position',
    span: 24,
  },
  {
    label: 'Organizational Unit Name',
    width: 260,
    prop: 'organizationalUnitName',
    span: 24,
  },
  {
    label: '报名课程数',
    prop: 'activityCount',
    overHidden: true,
    width: 130,
    sortable: true,
  },
    {
    label: '报名子项目数',
    prop: 'projectCount',
    overHidden: true,
    width: 130,
    sortable: true,
  },
  {
    label: '签到子项目数',
    prop: 'checkedInCount',
    overHidden: true,
    width: 130,
    sortable: true,
  }]
}

export const categoryTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  editBtn: false,
  delBtn: false,
  align: 'center',
  addBtn: false,
  columnBtn: false,
  menu:false,
  page:false,
  indexFixed:true,
  column: [
  {
    label: '课程类别',
    prop: 'category',
    span: 24,
  },      
  {
    label: '培训课程数',
    prop: 'activityCount',
    span: 24,
    sortable: true,
  },
  {
    label: '子项目数',
    prop: 'projectCount',
    span: 24,
    sortable: true,
  }]
}